import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import SearchPage from './pages/SearchPage';
import DashboardPage from './pages/DashboardPage';
import ImportsPage from './pages/ImportsPage';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<SearchPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/imports" element={<ImportsPage />} />
          </Routes>
        </main>
        <footer className="footer">
          <div className="container">
            <p>© 2024 eBay Feed System - Powered by Elasticsearch & React</p>
          </div>
        </footer>
      </div>
    </Router>
  );
};

export default App;
